import { FIXED_DECIMAL_PLACES, bigFromFee } from 'utils/price'
import { ProductDetailsWithQuantityDTO, ProductListItemDTO, ProductQuantityDTO } from 'models/purchaseFlow'
import { PurchaseFlowProduct, PurchaseFlowProductOption } from 'components/pages/PurchaseFlow/_main/contexts/PurchaseFlowProducts.context'

import { aggregateOptionsAcrossParents } from './aggregateOptionsAcrossParents'

export interface BuildPurchaseFlowProductsListParams {
  selectedProducts: Record<number, PurchaseFlowProduct>
  selectedProductOptions: Record<number, Record<number, PurchaseFlowProductOption>>
  shouldIncludeProduct: (product: PurchaseFlowProduct) => boolean
  productNameByIdResolver: (id: number) => string
  fullItem?: boolean
  tracking?: boolean
}

export function buildPurchaseFlowProductsList(params: BuildPurchaseFlowProductsListParams): ProductQuantityDTO[] | ProductListItemDTO[] | ProductDetailsWithQuantityDTO[] {
  const {
    selectedProducts,
    selectedProductOptions,
    shouldIncludeProduct,
    productNameByIdResolver,
    fullItem = false,
    tracking = false,
  } = params

  const quantityList: ProductQuantityDTO[] = []
  const fullList: ProductListItemDTO[] = []
  const trackingList: ProductDetailsWithQuantityDTO[] = []
  const includedParents: PurchaseFlowProduct[] = []

  for (const productKey in selectedProducts) {
    const product = selectedProducts[productKey]
    if (!shouldIncludeProduct(product)) continue

    includedParents.push(product)

    const productItem = {
      id: product.id,
      isOption: false,
      count: product.quantity,
      value: product.value,
    }

    if (fullItem) {
      fullList.push({
        ...productItem,
        name: productNameByIdResolver(product.id),
        pricePerItem: product.feePrice,
        comment: product.comment,
      })
    }

    if (tracking) trackingList.push({
      ...productItem,
      type: product.type,
      kind: product.kind,
      name: productNameByIdResolver(product.id),
      unitPrice: bigFromFee(product.feePrice).toFixed(FIXED_DECIMAL_PLACES),
    })

    else quantityList.push(productItem)
  }

  for (const { option, count, parentType, parentKind } of aggregateOptionsAcrossParents(includedParents, selectedProductOptions)) {
    const optionItem = {
      id: option.id,
      count,
      isOption: true,
      type: parentType,
      kind: parentKind,
    }

    if (fullItem) {
      fullList.push({
        ...optionItem,
        name: productNameByIdResolver(option.id),
        pricePerItem: option.feePrice,
      })
    }
    else quantityList.push(optionItem)
  }

  return fullItem ? fullList : (tracking ? trackingList : quantityList)
}
